import React, { useState, useEffect } from "react";
import "./style.scss";
import Navbar from "../navbar";
import Footer from "../footer";
import { states, retailerdata } from "./retailer.data";

import SEO from "../seo";
import indiaMap from "../../images/Map.png";

export default function StoreLocator() {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [areaOptionsArray, setAreaOptionsArray] = useState([]);

  function handleOnStateChange(e) {
    setSelectedState(e.target.value);
    setSelectedArea(null);
  }
  function handleOnAreaChange(e) {
    setSelectedArea(e.target.value);
  }

  useEffect(() => {
    if (selectedState !== null) {
      const areas = getStateAreas();
      setAreaOptionsArray(areas);
    }
  }, [selectedState]);

  function getStateAreas() {
    const areasWithState = retailerdata.filter(
      (item) => item.state === selectedState
    );

    const areas = new Set();

    areasWithState.forEach((item) => {
      areas.add(item.area);
    });
    return [...areas];
  }

  const stateOptions = states.sort().map((state, i) => (
    <option value={state} key={`state${i + 1}`}>
      {state}
    </option>
  ));

  const areaOptions = areaOptionsArray.sort().map((area, i) => (
    <option value={area} key={`area${i + 1}`}>
      {area}
    </option>
  ));

  let retailers = [];

  if (selectedState !== null && selectedArea !== null) {
    retailers = retailerdata.filter(
      (item) => item.state === selectedState && item.area === selectedArea
    );
  }
  const retailersJSX = retailers
    .sort((a, b) => {
      return a.name.localeCompare(b.name);
    })
    .map((item, i) => (
      <div className="storelocator__retailers__card">
        {/* <div>{item.area}</div> */}
        <div className="storelocator__retailers__card__name">{item.name}</div>
        {item.concernPerson && (
          <div className="storelocator__retailers__card__person">
            <i class="fas fa-user-alt"></i>
            {toTitleCase(item.concernPerson)}
          </div>
        )}
        <div className="storelocator__retailers__card__address">
          <i class="fas fa-address-book"></i>
          {toTitleCase(item.address)}
        </div>
      </div>
    ));

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  return (
    <div className="storelocator">
      <SEO
        title="Retail Stores | Locate a Store | Eclipse International"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
        description="Explore the range of premium handcrafted mattresses from America’s Sleep Specialist at the best retail stores in India. Find an Eclipse retailer near you."
      />
      <Navbar path="/store-locator/" />
      <div className="storelocator__content">
        <h1 className="heading-primary">Retail Stores</h1>
        <p className="storelocator__des">
          Get in touch with retailers of Eclipse International’s handcrafted
          mattresses and luxury bedding accessories PAN India. Explore retailer
          by state and district to pinpoint a retailer close to you.
        </p>
        <div className="storelocator__bottomcontainer">
          <h3 className="heading-secondary">Find a retailer store near you</h3>

          <div className="storelocator__selectors">
            <select onChange={handleOnStateChange}>
              <option
                selected={selectedState === null}
                style={{ display: "none" }}
              >
                ---Select State---
              </option>
              {stateOptions}
            </select>
            <select onChange={handleOnAreaChange}>
              <option
                selected={selectedArea === null}
                style={{ display: "none" }}
              >
                ---Select City / Area---
              </option>
              {areaOptions}
            </select>
          </div>

          {selectedArea && (
            <div className="storelocator__areaheading">{`${selectedArea} Retailers`}</div>
          )}
          {retailers.length > 0 ? (
            <div className="storelocator__retailers">{retailersJSX}</div>
          ) : (
            <div className="storelocator__map">
              <img alt="Map" src={indiaMap}></img>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
